<template>
  <div>
    <el-dialog
      v-if="game"
      :visible="true"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      :before-close="closePurchasePopup"
      width="40%"
      top="0"
    >
      <div class="iframe-ct" v-if="game.demo_game_url">
        <iframe
          :src="`${game.demo_game_url}${this.$store.state.app.user.email}`"
          frameborder="0"
        />
      </div>
      <div v-else>
        <el-image
          style="width: 100%; height: 350px"
          :src="game.demo_image_url"
          fit="scale-down"
        />
      </div>
      <div class="popup-game-description-ct">
        <p class="popup-game-title">{{ game.name }}</p>
        <p class="popup-game-description">
          {{ game.long_description }}
        </p>
        <div class="popup-game-info">
          <span class="popup-section-title">
            {{ $t('Gamification_GamesPopUp_Game_Type') }}
          </span>
          <span class="popup-game-type-tags">
            <el-tag
              v-for="game_type in game.game_type"
              :key="game_type"
              size="mini"
            >
              {{ $t(GameTypeLabel[game_type]) }}
            </el-tag>
          </span>
        </div>
        <div class="popup-game-info">
          <span class="popup-section-title">
            {{ $t('Gamification_GamesPopUp_Segmentation') }}
          </span>
          <span class="popup-segment-section">
            <icon
              :glyph="getSegmentationIcon"
              size="20"
              :style="segmentationIconStyle"
            />
            {{
              game.segmentation
                ? $t('Gamification_GamesPopUp_Segmentation_Yes')
                : $t('Gamification_GamesPopUp_Segmentation_No')
            }}
          </span>
        </div>
        <div class="popup-game-info">
          <span class="popup-section-title">{{
            $t('Gamification_GamesPopUp_Design')
          }}</span>
          <span class="popup-game-description">
            {{ $t('Gamification_GamesPopUp_Design_Description') }}
          </span>
        </div>
      </div>
      <div class="popup-game-btn-ct">
        <el-button type="primary" @click="requestGame(game.name)">
          {{ $t('Gamification_Request_Game') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { ProductRequestTypesEnum } from '@/common/enum/ProductRequestTypesEnum'
import { GameTypeLabel } from '@/modules/gamification/enum/GameTypeEnum'

export default {
  name: 'GamePopUp',
  props: {
    game: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      GameTypeLabel
    }
  },
  methods: {
    closePurchasePopup() {
      this.$emit('close')
    },
    requestGame(game) {
      RestApi({
        method: 'post',
        url: `projects/${this.$route.query.project_id}/notification`,
        data: {
          productName: ProductRequestTypesEnum.GAMIFICATION,
          content: game
        }
      })
        .then(() => {
          this.$message({
            message: this.$t(
              'Gamification_Book_A_Demo_Interested_In_Gamification_Request_Sent'
            ),
            type: 'success'
          })
        })
        .catch(() => {
          this.$message({
            message: this.$t(
              'Gamification_Book_A_Demo_Interested_In_Gamification_Request_Failed'
            ),
            type: 'error'
          })
        })
    }
  },
  computed: {
    getSegmentationIcon() {
      return this.game.segmentation ? 'check-circle' : 'cancel-circle'
    },
    segmentationIconStyle() {
      return {
        minWidth: '20px',
        color: this.game.segmentation ? '#1d87c9' : '#ed1d27'
      }
    }
  }
}
</script>

<style scoped>
>>> .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

>>> .el-dialog__body {
  overflow: auto;
}

.iframe-ct {
  padding: 0 30px;
}

iframe {
  width: 100%;
  height: 350px;
}

.popup-game-description-ct {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 30px;
}

.popup-section-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: #4b515f;
  max-width: max-content;
  min-width: max-content;
}

.popup-game-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #4b515f;
}

.popup-game-description {
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #7e8596;
}

.popup-game-btn-ct {
  display: flex;
  justify-content: flex-end;
  padding-right: 30px;
}

.popup-game-info {
  display: flex;
  gap: 10px;
  align-items: center;
}

.popup-game-type-tags {
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.popup-segment-section {
  display: flex;
  align-items: center;
  gap: 5px;
}

@media screen and (max-height: 850px) {
  >>> .el-dialog__body {
    height: 550px;
  }
}

@media screen and (max-height: 700px) {
  >>> .el-dialog__body {
    height: 400px;
  }
}

@media screen and (max-width: 1200px) {
  >>> .el-dialog {
    width: 60% !important;
  }
}

@media screen and (max-width: 900px) {
  >>> .el-dialog {
    width: 70% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-dashboard/GamePopUp.vue